import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Reveal, Label } from "@/components/Reveal";
import { INITIATIVES } from "@/data/content";

export default function Initiatives() {
  return (
    <div data-testid="initiatives-page" className="pt-20">
      <section className="py-28 md:py-36 border-b border-white/5">
        <div className="max-w-5xl mx-auto px-6 md:px-12">
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
          >
            <Label className="block mb-6">Featured Initiatives</Label>
            <h1 className="font-display font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.08] text-[#F4F1ED]">
              What we carry forward, together.
            </h1>
            <p className="mt-8 max-w-2xl text-lg md:text-xl text-[#A8A5A1] leading-relaxed">
              Each initiative begins with community and returns to Country. Together they
              become something greater than any single archive.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Bento tiles */}
      <section className="py-16 md:py-24">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 auto-rows-[260px] gap-4">
            {INITIATIVES.map((it, i) => (
              <Reveal key={it.name} delay={(i % 4) * 0.06} className={it.span}>
                <div
                  data-testid={`initiative-tile-${i}`}
                  className={`group relative h-full w-full rounded-lg overflow-hidden ${it.span}`}
                >
                  <img
                    src={it.img}
                    alt={it.name}
                    className="absolute inset-0 h-full w-full object-cover group-hover:scale-105 transition-transform duration-[1400ms]"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#050806] via-[#050806]/30 to-transparent group-hover:from-[#050806]/90 transition-colors duration-700" />
                  <div className="relative z-10 h-full flex flex-col justify-end p-7">
                    <span className="wk-label">{it.tag}</span>
                    <h3 className="mt-2 font-display text-3xl md:text-4xl text-[#F4F1ED]">
                      {it.name}
                    </h3>
                    <p className="mt-2 text-sm text-[#D8D4CE]/80 max-w-md opacity-0 group-hover:opacity-100 translate-y-2 group-hover:translate-y-0 transition-all duration-500">
                      {it.body}
                    </p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-24 md:py-32 border-t border-white/5">
        <div className="max-w-4xl mx-auto px-6 md:px-12 text-center">
          <Reveal>
            <h2 className="font-display font-light text-3xl sm:text-4xl lg:text-5xl text-[#F4F1ED]">
              There is a place for you in this work.
            </h2>
            <Link
              to="/partner"
              data-testid="initiatives-cta-link"
              className="mt-10 inline-flex items-center gap-2 px-8 py-4 rounded-md bg-[#D4A373] text-[#050806] font-medium hover:bg-[#E6CCB2] transition-colors duration-500"
            >
              Become a Wisdom Keeper <ArrowRight size={18} />
            </Link>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
